/* SCRIPTS IMPORT CONTROL
Any custom built scripts from /custom or third - party library scripts from /lib must be listed here
This enables modular control of what is merged and minified, or deactivated if currently not needed.
*/

// mobileMenu
import { mobileMenu } from "./custom/custom";
mobileMenu();

// navHovers
import { navHovers } from "./custom/custom";
navHovers();

// form control
import { formControl } from "./custom/custom";
formControl();

// form control 2
import { formControl2 } from "./custom/custom";
formControl2();

// multiple accordions
import { multipleAccord } from "./custom/custom";
multipleAccord();

// play video
import { playVideo } from "./custom/custom";
playVideo();

// modals
import { modals } from "./custom/custom";
modals();

// Carousel
//import { carousel } from "./custom/custom";
//carousel();

// Hash Change Scroll Buffer
import { hashChangeScrollBuffer } from "./custom/custom";
hashChangeScrollBuffer();
